import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "progress", "progressBar", "progressText"]
  static values = {
    itemId: Number,
    url: String
  }

  connect() {
    this.uploading = false
  }

  disconnect() {
    this.uploading = false
  }

  openPicker() {
    if (!this.uploading) {
      this.inputTarget.click()
    }
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.add("border-indigo-500", "bg-indigo-50")
  }

  handleDragLeave(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove("border-indigo-500", "bg-indigo-50")
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove("border-indigo-500", "bg-indigo-50")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.uploadFiles(files)
    }
  }

  handleFiles(event) {
    const files = event.target.files
    if (files.length > 0) {
      this.uploadFiles(files)
    }
  }

  async uploadFiles(files) {
    if (this.uploading) return
    this.uploading = true

    this.showProgress()
    const totalFiles = files.length
    let uploadedFiles = 0

    for (const file of files) {
      try {
        await this.uploadFile(file)
        uploadedFiles++
        this.updateProgress((uploadedFiles / totalFiles) * 100)
      } catch (error) {
        console.error("Upload failed:", error)
      }
    }

    this.hideProgress()
    this.uploading = false
    this.inputTarget.value = ""
  }

  async uploadFile(file) {
    const formData = new FormData()
    formData.append("item_media[file]", file)
    formData.append("item_media[media_type]", this.detectMediaType(file))

    const response = await fetch(this.urlValue, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status}`)
    }

    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }

  detectMediaType(file) {
    if (file.type.startsWith("video/")) {
      return "video"
    }
    return "photo"
  }

  showProgress() {
    if (this.hasProgressTarget) {
      this.progressTarget.classList.remove("hidden")
    }
  }

  hideProgress() {
    if (this.hasProgressTarget) {
      this.progressTarget.classList.add("hidden")
    }
  }

  updateProgress(percent) {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percent}%`
    }
    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = `${Math.round(percent)}%`
    }
  }
}
